<template>
        <app-layout :nav_type="null" :footer_image="false">
            <!-- Hero Start -->
            <section class=" bg-circle-gradiant d-flex align-items-center bg-half-170 ">
                <div class="bg-overlay bg-overlay-white"></div>
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-5 col-md-8">
                            <div class="card login-page shadow rounded border-0">
                                <div class="card-body">
                                    <h4 class="card-title text-center mb-4">Change password</h4>

                                    <form @submit.prevent="create">

                                        <div class="ec-login-wrap mb-3">
                                            <label for="login-old_password">Current Password</label>
                                            <input type="password" class="form-control m-0" id="login-old_password"
                                                   placeholder=""
                                                   aria-label="phone" aria-describedby="old_password"
                                                   v-model="item.old_password"
                                                   :class="{ 'is-invalid' : isInvalid('old_password')}">

                                            <div class="invalid-feedback text-danger" v-if="isInvalid('old_password')">
                                                {{ isInvalid('old_password') }}
                                            </div>
                                        </div>

                                        <div class="ec-login-wrap mb-3">
                                            <label for="login-password">New Password</label>
                                            <input type="password" class="form-control m-0" id="login-password"
                                                   placeholder=""
                                                   aria-label="phone" aria-describedby="password"
                                                   v-model="item.password"
                                                   :class="{ 'is-invalid' : isInvalid('password')}">

                                            <div class="invalid-feedback text-danger" v-if="isInvalid('password')">
                                                {{ isInvalid('password') }}
                                            </div>
                                            <small class="text-brand-primary">يجب ان تتكون من ٨ احرف وارقام </small>
                                        </div>

                                        <div class="ec-login-wrap mb-3">
                                            <label for="login-confirmPassword">Confirm Password</label>
                                            <input type="password" class="form-control m-0" id="login-confirmPassword"
                                                   placeholder=""
                                                   aria-label="phone" aria-describedby="confirmPassword"
                                                   v-model="item.confirmPassword"
                                                   :class="{ 'is-invalid' : isInvalid('confirmPassword')}">

                                            <div class="invalid-feedback text-danger" v-if="isInvalid('password')">
                                                {{ isInvalid('confirmPassword') }}
                                            </div>
                                        </div>


                                        <span class="ec-login-wrap ec-login-btn">
                                            <button class="btn btn-primary"
                                                    type="submit">
                                                Change password
                                            </button>
                                        </span>
                                    </form>
                                </div>
                            </div><!---->
                        </div><!--end col-->
                    </div><!--end row-->
                </div> <!--end container-->
            </section><!--end section-->
            <!-- Hero End -->
        </app-layout>
</template>


<script setup>
import {ref} from 'vue'
import {useHead} from "@vueuse/head"

const count = ref(0)
useHead({
    title: 'Change password',
})
</script>

<script>

import {useToast} from "vue-toastification";

const toast = useToast();
import AppLayout from "../../app-layout.vue";

// import Utility from '../../utility'
// import {Bootstrap5Pagination} from "laravel-vue-pagination";

export default {
    inject: ['auth'],
    components: {
        AppLayout
        // Bootstrap5Pagination,
    },
    watch: {
        '$userLoggedIn.value': function (newVal) {
            if (newVal === false) {
                this.$router.push({name: 'home', params: {lang: this.$i18n.locale}});
            }
        },
    },
    data() {
        return {
            show_old_password: false,
            show_password: false,
            show_confirmPassword: false,
            error: null,
            item: {},
            validationErrors: null,

        }
    },
    created() {

        // if(this.auth.isLoggedIn() === false){
        //     this.$router.push({name: 'home'});
        // }

    },
    methods: {
        isInvalid(name) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        create() {
            const id = toast.info('Save password...', {icon: 'fa-solid fa-cloud-arrow-up'});

            const that = this;
            this.validationErrors = null;

            axios.post('change_password',
                this.item
            ).then(response => {
                toast.dismiss(id);

                toast.success(response.data.message, {
                    timeout: 3000,
                }, {icon: 'fa-solid fa-circle-check'});


                that.error = null;

                this.$router.push({name: 'home', params: {lang: this.$i18n.locale}});

            }).catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    that.error = error.response.data.message;
                    that.validationErrors = error.response.data.errors;
                }
            });

        },
    }
}
</script>
